var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.707 22.223 100.755 1.292A4.416 4.416 0 0 0 97.633 0H19.5a4.414 4.414 0 0 0-4.416 4.41v127.237a4.414 4.414 0 0 0 4.416 4.41h99.086a4.413 4.413 0 0 0 4.415-4.41V25.343a4.41 4.41 0 0 0-1.293-3.12z",
    fill: "#A0CDF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.707 22.223 100.755 1.292A4.416 4.416 0 0 0 97.633 0H62.956v136.058h55.63a4.413 4.413 0 0 0 4.414-4.41V25.342a4.41 4.41 0 0 0-1.293-3.12z",
    fill: "#5BA9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.833 24.146-19.17-.06a4.413 4.413 0 0 1-4.402-4.41V.31c.553.218 1.063.55 1.493.98l20.952 20.931a4.361 4.361 0 0 1 1.127 1.924z",
    fill: "#076DC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.006 90.046C13.461 90.046 0 103.493 0 120.023 0 136.552 13.46 150 30.006 150s30.006-13.448 30.006-29.977c0-16.53-13.461-29.977-30.006-29.977z",
    fill: "#00B3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.201 120.364a4.416 4.416 0 0 0-6.16-1.02l-4.62 3.302v-14.253a4.412 4.412 0 0 0-4.415-4.41 4.412 4.412 0 0 0-4.415 4.41v14.047l-4.094-3.046a4.418 4.418 0 0 0-6.179.902 4.41 4.41 0 0 0 .904 6.173l11.146 8.294c.03.023.063.043.094.064a3.559 3.559 0 0 0 .34.216c.047.028.094.057.143.083.078.041.158.08.238.115.045.02.089.042.133.06a5 5 0 0 0 .34.125c.05.016.101.029.153.043a4.147 4.147 0 0 0 .652.13 4.369 4.369 0 0 0 .544.038h.001a4.3 4.3 0 0 0 .402-.02c.045-.003.09-.01.134-.015a4.028 4.028 0 0 0 .411-.068c.09-.021.179-.044.268-.07l.116-.031c.118-.038.235-.081.35-.128.048-.02.095-.044.143-.064.07-.034.142-.067.212-.103.05-.026.098-.053.147-.08a7.02 7.02 0 0 0 .199-.12l.135-.09.052-.034 11.605-8.295a4.408 4.408 0 0 0 1.021-6.155z",
    fill: "#C8FFF4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#388CD0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.452 48.55H41.584a4.414 4.414 0 0 1-4.415-4.411 4.413 4.413 0 0 1 4.415-4.41h32.868a4.413 4.413 0 0 1 4.415 4.41 4.414 4.414 0 0 1-4.415 4.411zM94.763 65.9h-53.18a4.413 4.413 0 0 1-4.414-4.41 4.413 4.413 0 0 1 4.415-4.411h53.179a4.413 4.413 0 0 1 4.415 4.41 4.413 4.413 0 0 1-4.415 4.41zM94.763 83.25h-53.18a4.413 4.413 0 0 1-4.414-4.41 4.414 4.414 0 0 1 4.415-4.412h53.179a4.414 4.414 0 0 1 4.415 4.411 4.413 4.413 0 0 1-4.415 4.411z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.452 39.728H62.956v8.822h11.496a4.414 4.414 0 0 0 4.415-4.411 4.413 4.413 0 0 0-4.415-4.41zM94.763 57.079H62.956v8.82h31.807a4.413 4.413 0 0 0 4.415-4.41 4.413 4.413 0 0 0-4.415-4.41zM94.763 74.428H62.956v8.822h31.807a4.413 4.413 0 0 0 4.415-4.41 4.414 4.414 0 0 0-4.415-4.412z",
    fill: "#0D72C4"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };